import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/listeaza-vehicul/")({
  head: () => routeHead("/listeaza-vehicul/"),
  beforeLoad: () => {
    throw redirect({ href: "/listeaza", statusCode: 301, replace: true });
  },
});
